import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles(() => ({
  title: {
    marginBottom: "-0.8rem",
  },
}));
